import { PatientDetailComponent } from './../pages/consultation-process/patient-detail/patient-detail.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { authProviders, AuthGuard } from '../auth.guard';
import { noAuthRoutes } from './no-auth.routing.module';
import { ModuleWithProviders } from '@angular/core';
import { Error404Component } from '../pages/error/404.component';
import { LayoutComponent } from '../components/layout/layout.component';
import { SelectCentreComponent } from '../pages/select-centre/select-centre.component';
import { ReportComponent } from '../pages/report/report.component';
import { CardPageComponent } from '../components/layout/card-page.component';
import { NewsComponent } from '../pages/news/news.component';

import { CreatePasswordComponent } from '../pages/create-password/create-password.component';
// main routing
const appRoutes: Routes = [
  {
    path: 'news',
    component: NewsComponent,
    // children: [
    //   {
    //     path: '',
    //     loadChildren: '../pages/news/news.module#NewsModule',
    //   }
    // ]
  },
  {
    path: 'change-password',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: '../pages/change-password/change-password.module#ChangePassModule',
        // canLoad: [AuthGuard]
      },
    ]
  },
  {
    path: 'create-password/:id',
    component: CreatePasswordComponent     
  },
  {
    path: 'centre', // centre
    component: LayoutComponent,
    //canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: '../pages/centre/centre.module#CentreModule',
      }
    ]
  },
  {
    path: 'master-data', // master-data
    component: LayoutComponent,
    //canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: '../pages/master-data/master-data.module#MasterDataModule',
        //   canLoad: [AuthGuard]
      },
    ]
  },
  {
    path: 'consultation-process', // consultation-process
    component: LayoutComponent,
    loadChildren: '../pages/consultation-process/consultation-process.module#ConsultationProcessModule'
  },
  {
    path: 'consultation', // consultation
    component: LayoutComponent,
    //canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: '../pages/consultation/consultation.module#ConsultationModule',
        //   canLoad: [AuthGuard]
      },
    ]
  },
  {
    path: 'payment', // payment
    component: LayoutComponent,
    // canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: '../pages/payment/payment.module#PaymentModule',
        //   canLoad: [AuthGuard]
      },
    ]
  },
 
  {
    path: 'administration',
    children: [
      {
        path: '',
        loadChildren: '../pages/administration/administration.module#AdministrationModule',
      },
    ]
  },

  /*{
    path: 'patient-information',
    component: LayoutComponent,
    // canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: '../pages/patient-information/patient-information.module#PatientInformationModule',
        //   canLoad: [AuthGuard]
      },
    ]
  },*/
  {
    path: 'booking', // centre
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: '../pages/booking/booking.module#BookingModule',
      },
    ]
  },
  {
    path: 'report',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: '../pages/report/report.module#ReportModule'
      }
    ]
  },
  {
    path: 'select-centre',
    component: CardPageComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: '../pages/select-centre/select-centre.module#SelectCentreModule',
      }
    ]
  },
  {
    // default routes
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full'
  },
  { path: '**', component: Error404Component } // 404*/

];


@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AuthGuard
  ]
})

export class AppRoutingModule {
}






// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/routes/app.routing.module.ts